import {$WS} from "../webSocketProtoHead";
import {MSG} from "../../proto/proto";
import {SUB} from "../wsProtoConfigBase";

export default class SubBase implements $WS.WebSocketProtoHeadBody {
    //协议头
    static readonly HEAD: number = SUB.SubBase;
    //
    readonly head: number;
    body: string;

    constructor() {
        this.head = SubBase.HEAD;
    }

    getPackageBody(): Uint8Array {
        return null;
    }

    static unPackageMessage(data: Uint8Array): SubBase {
        return new SubBase();
    }
}